module.exports = __webpack_public_path__ + "static/media/fruit-03.86a5a1b3.png";